import { twMerge } from 'tailwind-merge';
import { DEFAULT_LANGUAGE, SupportedLanguage } from '@/models/TranslatableField';
import { QuestionViewProvider } from './context/QuestionViewContext';
import { questionDirectorFactory } from './directors/questionDirectorFactory';
import { QuestionViewProps } from './types';

type QuestionViewComponentProps = QuestionViewProps & {
  language?: SupportedLanguage;
  className?: string;
};

export function QuestionView({
  language = DEFAULT_LANGUAGE,
  className,
  ...viewProps
}: QuestionViewComponentProps) {
  const Director = questionDirectorFactory(viewProps.mode);

  return (
    <QuestionViewProvider
      question={viewProps.question}
      mode={viewProps.mode}
      language={language}
    >
      <div className={twMerge('flex flex-col gap-6 py-4', className)}>
        <Director {...viewProps} />
      </div>
    </QuestionViewProvider>
  );
}
